import { css } from 'styled-components';

const button = css`
  color: var(--text-main);
  background-color: var(--surface-light);
  border: 1px solid var(--text-dark);
  border-radius: 100px;
  font-size: var(--fz-xs);
  font-family: var(--font-heading);
  font-weight: 600;
  line-height: 1;
  text-decoration: none;
  padding: 1.25rem 2rem;
  transition: var(--transition);
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover,
  &:focus-visible {
    outline: none;
    background-color: var(--accent-main);
    border-color: var(--accent-main);
    box-shadow: var(--accent-glow);
    transform: translateY(-2px);
    color: var(--bg-color);
  }
`;

const mixins = {
  flexCenter: css`
    display: flex;
    justify-content: center;
    align-items: center;
  `,

  flexBetween: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,

  link: css`
    display: inline-block;
    text-decoration: none;
    text-decoration-skip-ink: auto;
    color: inherit;
    position: relative;
    transition: var(--transition);

    &:hover,
    &:focus-visible {
      color: var(--accent-main);
      outline: 0;
    }
  `,

  inlineLink: css`
    display: inline-block;
    position: relative;
    color: var(--accent-main);
    transition: var(--transition);

    &:hover,
    &:focus-visible {
      color: var(--accent-main);
      outline: 0;
      &:after {
        width: 100%;
      }
      & > * {
        color: var(--accent-main) !important;
        transition: var(--transition);
      }
    }
    &:after {
      content: '';
      display: block;
      width: 0;
      height: 1px;
      position: relative;
      bottom: 0.1em;
      background-color: var(--accent-main);
      transition: var(--transition);
    }
  `,

  button,

  smallButton: css`
    color: var(--text-main);
    background-color: transparent;
    border: 1px solid var(--text-dark);
    border-radius: 100px;
    padding: 0.75rem 1.5rem;
    font-size: var(--fz-xs);
    font-family: var(--font-heading);
    font-weight: 600;
    line-height: 1;
    text-decoration: none;
    transition: var(--transition);

    &:hover,
    &:focus-visible {
      outline: none;
      background-color: var(--text-main);
      color: var(--bg-color);
      transform: translateY(-2px);
    }
  `,

  bigButton: css`
    color: var(--text-main);
    background-color: var(--accent-main);
    border: none;
    border-radius: 100px;
    padding: 1.5rem 2.5rem;
    font-size: var(--fz-sm);
    font-family: var(--font-heading);
    font-weight: 700;
    line-height: 1;
    text-decoration: none;
    transition: var(--transition);
    display: inline-block;

    &:hover,
    &:focus-visible {
      outline: none;
      box-shadow: var(--accent-glow);
      transform: translateY(-4px);
    }
  `,

  boxShadow: css`
    box-shadow: 0 10px 30px -15px rgba(0,0,0,0.7);
    transition: var(--transition);

    &:hover,
    &:focus-visible {
      box-shadow: 0 20px 30px -15px rgba(0,0,0,0.9);
    }
  `,

  fancyList: css`
    padding: 0;
    margin: 0;
    list-style: none;
    font-size: var(--fz-lg);
    li {
      position: relative;
      padding-left: 30px;
      margin-bottom: 10px;
      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--accent-main);
      }
    }
  `,

  resetList: css`
    list-style: none;
    padding: 0;
    margin: 0;
  `,
};

export default mixins;
